"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokerRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const broker_entity_1 = require("../../../../service-lib/src/lib/entities/broker.entity");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const broker_address_entity_1 = require("../../../../service-lib/src/lib/entities/broker-address.entity");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const broker_contact_entity_1 = require("../../../../service-lib/src/lib/entities/broker-contact.entity");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const constants_2 = require("../../../../service-lib/src/lib/constants");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
let BrokerRepository = class BrokerRepository {
    constructor(brokerRepository, brokerAddressRepository, brokerContactRepository, lookUpRepository, entityService, scopeService) {
        this.brokerRepository = brokerRepository;
        this.brokerAddressRepository = brokerAddressRepository;
        this.brokerContactRepository = brokerContactRepository;
        this.lookUpRepository = lookUpRepository;
        this.entityService = entityService;
        this.scopeService = scopeService;
    }
    /** Add a new broker using a transaction */
    async addBroker(queryRunner, createBrokerDto) {
        try {
            const broker = queryRunner.manager.create(broker_entity_1.Broker, createBrokerDto);
            return await queryRunner.manager.save(broker);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, messages_1.errorMessages.failedToAddBroker || error.message));
        }
    }
    /** Find a broker by name */
    async findBrokerByName(brokerName) {
        try {
            return await this.brokerRepository.findOne({
                where: { brokerName: (0, typeorm_2.ILike)(`%${brokerName}%`) },
            });
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToFetchBrokers || error.message));
        }
    }
    /** Add a new broker address using a transaction */
    async addBrokerAddress(queryRunner, brokerAddress) {
        await queryRunner.manager.save(brokerAddress);
    }
    /** Fetch all brokers with pagination, search, and sorting */
    async fetchAllBrokers(page, limit, searchArray, sort, searchBy, userId) {
        const relations = [
            "brokerAddresses", // ← parent
            "brokerAddresses.address", // ← child
            "brokerAddresses.address.cityId",
            "brokerAddresses.address.stateId",
            "brokerContacts", // ← parent
            "brokerContacts.contact", // ← child
            "brokerContacts.contact.contactAddresses", // ← nested parent
            "brokerContacts.contact.contactAddresses.address", // ← nested child
            "status",
            "companyType",
        ];
        const status = await this.lookUpRepository.findOne({
            where: { lookUpKey: constants_1.DEFAULT_BROKER_STATUS_ACTIVE },
        });
        const whereCondition = {
            statusLid: status?.id ?? undefined,
        };
        const { data, count } = await this.scopeService.validateScope({
            entity: "broker",
            page: page,
            limit: limit,
            sort: sort && sort.length > 0 ? sort : [{ field: "id", order: "ASC" }],
            relations: relations,
            where: whereCondition,
            select: undefined,
            searchArray: searchArray && searchArray?.length === 0 ? [] : searchArray,
            userFilter: undefined,
            searchString: searchBy,
            searchOn: constants_2.BrokerSearchObject,
        }, userId, "broker");
        // const { data, count } = await this.entityService.fetchEntityList(
        //   "broker",
        //   page,
        //   limit,
        //   sort.length > 0 ? sort : [{ field: "id", order: "ASC" }],
        //   relations,
        //   whereCondition,
        //   undefined,
        //   searchArray.length === 0 ? [] : searchArray,
        //   undefined,
        //   searchBy,
        //   BrokerSearchObject
        // );
        const transformedData = data.map((broker) => ({
            id: broker.id,
            brokerName: broker.brokerName,
            displayName: broker.displayName,
            status: broker.status
                ? {
                    id: broker.status.id,
                    lookUpValue: broker.status.lookUpValue,
                }
                : null,
            companyType: broker.companyType
                ? {
                    id: broker.companyType.id,
                    lookUpValue: broker.companyType.lookUpValue,
                }
                : null,
            brokerAddresses: broker.brokerAddresses?.map((address) => ({
                id: address.id,
                address1: address.address?.address1,
                city: address.address?.cityId,
                state: address.address?.stateId,
                phoneNumber: address.address?.phoneNumber,
            })),
        }));
        return { data: transformedData, count };
    }
    /** Fetch a broker by ID */
    async fetchBrokerById(brokerId) {
        const broker = await this.brokerRepository.findOne({
            where: { id: brokerId },
            relations: [
                "brokerAddresses",
                "brokerAddresses.address.addressType",
                "status",
                "companyType",
            ],
        });
        if (!broker) {
            throw new common_1.NotFoundException(`broker with ID ${brokerId} not found`);
        }
        return await this.transformBroker(broker);
    }
    /** Fetches an broker by its ID. */
    async getBrokerById(brokerId) {
        try {
            const broker = await this.brokerRepository.findOne({
                where: { id: brokerId },
                relations: ["brokerAddresses.address.addressType", "status"],
            });
            if (!broker) {
                throw new common_1.NotFoundException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.brokerNotFound));
            }
            return broker;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.brokerNotFound));
        }
    }
    /** Add a Broker Address mapping data in BrokerAddress table */
    async addBrokerAddressMap(brokerAddress) {
        try {
            const brokerAddressData = this.brokerAddressRepository.create(brokerAddress);
            await this.brokerAddressRepository.save(brokerAddressData);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, messages_1.errorMessages.failedToSaveBrokerAddressMapping || error.message));
        }
    }
    /** Finds the broker company and address data mapping in BrokerAddress Table */
    async findBrokerCompanyAddressMap(companyId, addressId) {
        return this.brokerAddressRepository.findOne({
            where: {
                broker: { id: companyId },
                address: { id: addressId },
            },
        });
    }
    /** Saves an broker-company contact mapping to the database. */
    async addBrokerContact(brokerContact) {
        try {
            await this.brokerContactRepository.save(brokerContact);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToSaveBrokerContactMapping || error.message));
        }
    }
    /** Remove an broker contact details mapping*/
    async delinkBrokerContactMap(docObject) {
        try {
            await this.brokerContactRepository.delete(docObject);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.brokerContactMappingDeletionFailed || error.message));
        }
    }
    /** Transforms the broker data to match the required response structure */
    transformBroker(broker) {
        const mapAddress = (brokerAddress) => ({
            id: brokerAddress.address?.id,
            addressTypeLid: brokerAddress.address?.addressTypeLid,
            addressType: mapLookup(brokerAddress.address?.addressType),
            address1: brokerAddress.address?.address1,
            countryId: brokerAddress.address?.countryId
                ? {
                    name: brokerAddress.address.countryId.name,
                    isoCode: brokerAddress.address.countryId.isoCode,
                    id: brokerAddress.address.countryId.id,
                }
                : null,
            stateId: brokerAddress.address?.stateId
                ? {
                    name: brokerAddress.address.stateId.name,
                    stateCode: brokerAddress.address.stateId.stateCode,
                    id: brokerAddress.address.stateId.id,
                }
                : null,
            cityId: brokerAddress.address?.cityId
                ? {
                    name: brokerAddress.address.cityId.name,
                    id: brokerAddress.address.cityId.id,
                }
                : null,
            address2: brokerAddress.address?.address2,
            area: brokerAddress.address?.area,
            pinCode: brokerAddress.address?.pinCode,
            phoneNumber: brokerAddress.address?.phoneNumber,
            alternatePhoneNumber: brokerAddress.address?.alternatePhoneNumber,
            email: brokerAddress.address?.email,
            supportNumber: brokerAddress.address?.supportNumber,
        });
        const mapLookup = (lookup) => ({
            id: lookup?.id,
            lookUpValue: lookup?.lookUpValue,
        });
        return {
            id: broker.id,
            brokerName: broker.brokerName,
            displayName: broker.displayName,
            website: broker.website,
            remarks: broker.remarks,
            companyTypeLid: broker.companyTypeLid,
            companyType: mapLookup(broker.companyType),
            status: mapLookup(broker.status),
            brokerAddresses: broker.brokerAddresses?.map(mapAddress),
        };
    }
    /** Updates an existing broker in the database. */
    async modifyBroker(queryRunner, brokerId, updateBrokerDto) {
        try {
            const broker = await queryRunner.manager.findOne(broker_entity_1.Broker, {
                where: { id: brokerId },
            });
            if (!broker) {
                throw new common_1.NotFoundException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.brokerNotFound));
            }
            // Update the broker details
            await queryRunner.manager.update(broker_entity_1.Broker, brokerId, {
                ...updateBrokerDto,
            });
            const updatedbroker = await queryRunner.manager.findOne(broker_entity_1.Broker, {
                where: { id: brokerId },
            });
            if (!updatedbroker) {
                throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, messages_1.errorMessages.failedToModifyBroker));
            }
            return updatedbroker;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToModifyBroker));
        }
    }
    /** Removes an broker from the database by its ID. */
    async softDeleteBroker(brokerId) {
        try {
            await this.brokerRepository.update(brokerId, {
                deletedAt: new Date(),
            });
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToDeleteBroker || error.message));
        }
    }
    /** Fetches a paginated list of brokers based on various filters. */
    async fetchBrokerList(page, limit, search, sortBy, sortOrder, userId) {
        try {
            const status = await this.lookUpRepository.findOne({
                where: { lookUpKey: constants_1.DEFAULT_BROKER_STATUS_ACTIVE },
            });
            const [data, count] = await this.brokerRepository.findAndCount({
                where: {
                    brokerName: search ? (0, typeorm_2.ILike)(`%${search}%`) : undefined,
                    statusLid: status?.id ?? undefined,
                },
                order: { [sortBy]: sortOrder },
                skip: (page - 1) * limit,
                take: limit,
                select: ["id", "brokerName", "displayName"],
            });
            return { data, total: count };
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToFetchBrokers || error.message));
        }
    }
    /** Fetches broker details based on various conditions. */
    async fetchBrokerDetails(fields, relations, whereCondition) {
        try {
            const entityName = constants_1.DEFAULT_BROKER_ENTITY_NAME;
            const data = await this.entityService.getListOfValues(entityName, fields, whereCondition, relations);
            if (!data || data.length === 0) {
                throw new common_1.NotFoundException(messages_1.errorMessages.brokerNotFound);
            }
            return data;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToFetchBrokers));
        }
    }
    async getEntityTableMapIds(entity, select, whereCondition) {
        try {
            const data = await this.entityService.getEntityMapByIds(entity, select, whereCondition);
            return data;
        }
        catch (error) {
            return [];
        }
    }
    async deleteEntityTableMapIds(entity, deleteIds, select, deletionType) {
        try {
            await this.entityService.deleteEntityMapByIds(entity, deleteIds, select, deletionType);
        }
        catch (error) {
            throw new common_1.BadRequestException(error);
        }
    }
    /** Fetches broker contacts by broker ID. */
    async fetchBrokerContacts(brokerId) {
        try {
            const brokerContacts = await this.brokerContactRepository.find({
                where: { broker: { id: brokerId } },
                relations: ["contact"],
            });
            if (!brokerContacts || brokerContacts.length === 0) {
                return [];
            }
            return brokerContacts.map((brokerContact) => brokerContact.contact);
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException(`Failed to fetch contacts for broker with ID ${brokerId}.`);
        }
    }
};
exports.BrokerRepository = BrokerRepository;
exports.BrokerRepository = BrokerRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(broker_entity_1.Broker)),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(broker_address_entity_1.BrokerAddress)),
    tslib_1.__param(2, (0, typeorm_1.InjectRepository)(broker_contact_entity_1.BrokerContact)),
    tslib_1.__param(3, (0, typeorm_1.InjectRepository)(look_up_entity_1.LookUp)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object, typeof (_c = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _c : Object, typeof (_d = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _d : Object, typeof (_e = typeof entity_service_utils_1.EntityService !== "undefined" && entity_service_utils_1.EntityService) === "function" ? _e : Object, typeof (_f = typeof scope_utils_1.ScopeService !== "undefined" && scope_utils_1.ScopeService) === "function" ? _f : Object])
], BrokerRepository);
